import React from 'react';
import { Grid, Dropdown, Input, Button } from 'semantic-ui-react';
import Loading from '../../loading';
import Server from '../../../functions/server'
import $ from "jquery";
import CircularProgress from '@material-ui/core/CircularProgress';

class Add extends React.Component {

  state = {
    load: false,
    message: '',
    value: '',
    part_code: '',
  }

  componentDidMount() {
    this.getBrand();
    this.setvalueInState();
  }

  componentDidUpdate(props) {
    if (props.newhsncodevalue != this.props.newhsncodevalue) {
      this.setvalueInState();
    }
  }

  setvalueInState() {
    this.setState({ newhsncodevalue: this.props.newhsncodevalue, tax: this.props.newtaxvalue  })
  }

  getBrand() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Brands!!!'
    });
    let data1 = {};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'addmenu/branddetails/getallbrands.php',
      success: function(data)
      {
        console.log(data);
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          context.setBrand(data);
        } catch (e) {
          console.log(e);
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  setBrand(data) {
    let context = this;
    let datas = this.props.data;
    var x = [];
    data.map((y) => {
      let value = 0;
      datas.map((x) => {
        if (x.brand_id == y.id) {
          value = 1;
        }
      })
      if (value == 0) {
        let name = y.id + ' -> ' + y.brand_name;
        x.push({key: name, text: name, value: y.id});
      }
    });
    try {
      context.setState({
        brandOption: x,
      });
    } catch (e) {

    }
  }

  brand = (f, { value }) => {
    this.setState({
      value: value
    });
  }

  onChange = (type) => (e, {value}) => {
    this.setState({
      [type]: value
    })
  }

  add() {
    let context = this;
    let partno = this.props.partno;
    let value = this.state.value;
    let partCode = this.state.part_code;
    let dnp = this.state.dnp;
    let mrp = this.state.mrp;
    let tax = this.state.tax;
    let newtax = this.state.tax;
    let hsn = this.state.newhsncodevalue;

    if (tax < 10) {
      tax = '1.0'+tax;
    }
    else {
      tax = '1.'+tax;
    }
    tax = Number(tax);
    let point = this.state.point;
    let life = this.state.life;
    let ord_qty = this.state.ord_qty;
    let weight = this.state.weight;
    if (value == '' || value == null || value == undefined) {
      this.setState({ error: 'Select the Brand!!!' });
      return;
    }
    if (point == '' || point == null || point == undefined) {
      point = 0;
    }
    if (life == '' || life == null || life == undefined) {
      life = 0;
    }
    if (ord_qty == '' || ord_qty == null || ord_qty == undefined) {
      ord_qty = 0;
    }
    if (weight == '' || weight == null || weight == undefined) {
      weight = 0;
    }
    if (partCode == '' || partCode == null || partCode == undefined) {
      this.setState({ error: 'Enter the Part Code!!!' });
      return;
    }
    if (dnp == '' || dnp == null || dnp == undefined) {
      this.setState({ error: 'Enter the DNP!!!' });
      return;
    }
    if (mrp == '' || mrp == null || mrp == undefined) {
      this.setState({ error: 'Enter the MRP!!!' });
      return;
    }
    if (tax == '' || tax == null || tax == undefined) {
      this.setState({ error: 'Enter the tax!!!' });
      return;
    }
    if (hsn == '' || hsn == null || hsn == undefined) {
      this.setState({ error: 'Enter the hsn!!!' });
      return;
    }
    mrp = Number(mrp/tax);
    dnp = Number(dnp/tax);
    let data1 = { 'partno': partno, 'brand_id': value, 'point': point, 'life': life,
                  'ord_qty': ord_qty, 'weight': weight, 'part_code': partCode, 'dnp': dnp,
                  'mrp': mrp, 'tax': newtax, 'hsn': hsn };
    context.setState({ load: true, message: 'Adding Brand!!!' });
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/addbrand.php',
      success: function(data)
      {
        context.setState({
          load: false,
        })
        if (data == 1) {
          context.props.update();
        }
      },
      error: function(e)
      {
        alert('Try Again!!!');
        context.setState({
          load: false,
        })
        console.log(e);
      }
    })
  }

  render() {
    const { load, message, value } = this.state;
    return (
      <div>
        <Loading load={load} message={message} />
        <Grid>
          <Grid.Column mobil={16} tablet={16} computer={8}>
            Choose Brand<br/>
            <Dropdown
              id="brand" onChange={this.brand} fluid focus
              search selection options={this.state.brandOption}
              value={value} />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            Point<br/>
            <Input type="number" focus
              value={this.state.point}
              onChange={this.onChange('point')}
              style={{ borderColor: '#5A9CBB' }} fluid />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            Life<br/>
            <Input type="number" focus placeholder='life'
              value={this.state.life}
              onChange={this.onChange('life')}
              style={{ borderColor: '#5A9CBB' }} fluid />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            Min order Quality<br/>
            <Input type="number" focus
              value={this.state.ord_qty}
              onChange={this.onChange('ord_qty')}
              style={{ borderColor: '#5A9CBB' }} fluid />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            Weight<br/>
            <Input type="number" focus
              value={this.state.weight}
              onChange={this.onChange('weight')}
              style={{ borderColor: '#5A9CBB' }} fluid />
          </Grid.Column>
          <Grid.Column mobil={16} tablet={16} computer={8}>
            Part Code<br/>
            <Input focus value={this.state.part_code}
                onChange={this.onChange('part_code')}
                style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>

          <Grid.Column mobil={16} tablet={16} computer={8}>
            TAX<br/>
            <Input focus value={this.state.tax}
                onChange={this.onChange('tax')}
                style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobil={16} tablet={16} computer={8}>
            HSN CODE<br/>
            <Input focus value={this.state.newhsncodevalue}
                onChange={this.onChange('newhsncodevalue')}
                style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>



          <Grid.Column mobil={16} tablet={16} computer={8}>
            DNP<br/>
            <Input focus value={this.state.dnp}
                onChange={this.onChange('dnp')}
                style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobil={16} tablet={16} computer={8}>
            MRP<br/>
            <Input focus value={this.state.mrp}
                onChange={this.onChange('mrp')}
                style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobile={16} table={16} computer={16}>
            <div style={{color: 'red'}}><center>{this.state.error}</center></div>
          </Grid.Column>
          <Grid.Column mobil={16} tablet={16} computer={8}>
            <Button fluid onClick={ () => { this.props.handleClose(); } }>Cancel</Button>
          </Grid.Column>
          <Grid.Column mobil={16} tablet={16} computer={8}>
          {load ?
            (<div><center><CircularProgress size={18} color='secoundary' /></center></div>)
           :
            (<div><Button fluid onClick={this.add.bind(this)}>Save</Button></div>)}

          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default Add;
